import BlogDetailPage from "@/pages/blog/components/BlogDetailPage";

export default function BlogIntegratingAi() {
  return <BlogDetailPage slug="integrating-ai-into-laravel-applications" />;
}